module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-button-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-b77d2282!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/button/src/button-group.vue
// module id = 677
// module chunks = 0